import { PMSmallTable } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { theme } from "../../../theme";
import { DashboardCardContext } from "../context";

export function addTeamCard(ctx: DashboardCardContext) {
  const { view } = ctx;

  const teamComponent = view.addComponent({
    component: PMSmallTable,
    layoutProps: {
      componentId: "projectTeamComponent",
      title: "",
      description: "",
      labels: ["team"],
    },
  });

  teamComponent.mapLayoutProps(({ language }) => ({
    componentId: "projectTeamComponent",
    labels: ["team"],
    title: getLocalizedMessage(language, "programTeam"),
    description: getLocalizedMessage(language, "showsProgramTeam"),
  }));

  teamComponent.mapState(({ settings, language }) => {
    return {
      title: getLocalizedMessage(language, "programTeam"),
      icon: "InfoOutlined",
      items: [
        {
          label: getLocalizedMessage(language, "programOwner"),
          value: settings?.configuration?.programOwner ?? "",
          chipColor: theme.palette.secondary.main,
          chipTextColor: theme.palette.primary.main,
          cutValueAfter: 20,
        },
      ],
      fixedHeight: "134px",
    };
  });
}
